import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'content', 'trigger']

  connect() {}

  open(event) {
    const url = event.currentTarget.dataset.url

    fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.text())
      .then((html) => {
        const modalContainer = document.getElementById('modal_container')
        modalContainer.innerHTML = this._renderModal(html)
        modalContainer.classList.remove('pointer-events-none')

        const closeButtons = modalContainer.querySelectorAll('.modal-close')
        closeButtons.forEach((button) => {
          button.addEventListener('click', () => this.close())
        })
      })
      .catch((error) => {
        console.error('Error opening modal:', error)
      })
  }

  close() {
    const modalContainer = document.getElementById('modal_container')
    modalContainer.innerHTML = ''
    modalContainer.classList.add('pointer-events-none')
  }

  _renderModal(content) {
    return `
      <div class="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex justify-center items-center overflow-y-auto pointer-events-auto p-4">
        <div class="bg-white rounded-xl shadow-xl max-w-3xl w-full max-h-[90vh] overflow-hidden relative pointer-events-auto border border-gray-200 flex flex-col">
          <div class="flex items-center justify-end px-4 pt-3 pb-0 shrink-0">
            <button class="modal-close w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-900 hover:bg-gray-100 transition-colors" aria-label="Fechar">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
          <div class="px-6 pt-2 pb-6 overflow-y-auto flex-1">
            ${content}
          </div>
        </div>
      </div>
    `
  }
}
